var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h5',{attrs:{"dir":_vm.lang === 'en'?'ltr':'rtl'}},[_c('strong',[_vm._v(_vm._s(_vm.$t("booking.board-basis"))+" : ")]),_vm._v(" "+_vm._s(` ${_vm.basisName} - ${_vm.description}`)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }